import { useState } from 'react';
import { Info } from 'lucide-react';

interface ReasonTooltipProps {
  reason: string;
}

export function ReasonTooltip({ reason }: ReasonTooltipProps) {
  const [visible, setVisible] = useState(false);

  return (
    <span className="relative inline-block">
      <button
        type="button"
        className="text-blue-400 hover:text-blue-600 focus:outline-none"
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
        onFocus={() => setVisible(true)}
        onBlur={() => setVisible(false)}
        aria-label="Why is this suggested?"
      >
        <Info className="h-3.5 w-3.5" />
      </button>
      {visible && (
        <span
          role="tooltip"
          className="absolute left-5 top-0 z-50 w-48 rounded-md border border-gray-200 bg-white px-3 py-2 text-xs text-gray-700 shadow-lg"
        >
          {reason}
        </span>
      )}
    </span>
  );
}
